import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { string } from "prop-types";

import { DefaultFooter } from "./DefaultFooter";

import "./renderFooterComponents.m.css";

const RenderFooter = ({ domainSlug }) => {
  const [renderFooter, setRenderFooter] = useState(null);

  useEffect(() => {
    setRenderFooter(true);
  }, []);

  if (!renderFooter) {
    return false;
  }

  return (
    <div styleName="footer-wrapper" className="print-footer-wrapper">
      <DefaultFooter domainSlug={domainSlug} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

RenderFooter.propTypes = {
  domainSlug: string,
};

export default connect(mapStateToProps, () => ({}))(RenderFooter);
